import React from 'react';
import InfoCardGrid from './InfoCardGrid';
import { InfoCardData } from './types';
import AmortizationChart from '@/components/charts/AmmortizationChart';
import { Illustration } from './Illustration';

export const CommonGridReport = ({
  data,
  title,
  grid = 1,
  chart = false,
  report,
  notes,
  dataNotAvailable = false,
}: {
  grid?: number;
  data: InfoCardData[];
  title: string;
  chart?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  report?: any;
  notes?: string;
  dataNotAvailable?: boolean;
}) => {
  return (
    <div
      className={`grid grid-cols-1 md:grid-cols-${grid} ${grid == 1 ? '' : 'gap-x-[28px]'}  bg-[#fff] rounded-[10px] p-[16px]`}
    >
      <div>
        <h3 className="text-[20px] font-bold text-[#0C111D]">{title}</h3>
        <p className="text-[14px] font-normal text-[#0C111D] mb-[16px]">
          Wir haben die folgenden Ergebnisse für Sie errechnet:
        </p>
        {!dataNotAvailable ? <InfoCardGrid cards={data} /> : <Illustration title={title} />}
      </div>
      {!dataNotAvailable && chart ? <AmortizationChart report={report} /> : null}
      {notes && !dataNotAvailable ? (
        <p className={`col-span-${grid} text-[10px] font-bold`}>
          Hinweise: <span className="font-normal">{notes}</span>
        </p>
      ) : null}
    </div>
  );
};
